/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        // JavaScript to be fired on all pages
		// Fadein content on load
		/*
 		$(document).ready( function() {
			$(window).load(function() {
			  $('.wrap').animate({ "opacity" : 1 }, 200);
			});
			$('#menu-main-menu a, .wrap a, a.logo-home, a#nav-book').on('click', function() {
				event.preventDefault();
				newLocation = this.href;
				$('.wrap').animate({ "opacity" : 0 }, 200, 
				function() {
					window.location = newLocation;
				});
			}); 
		}); 
		*/
        // Initialize Bootstrap tooltips
        $(function () {
          $('[data-toggle="tooltip"]').tooltip()
        });
        // Deactivate top level links in main menu
        $(document).ready( function() {
            $('ul#menu-main-menu > li > a').on('click', function(e){
                e.preventDefault();
            });
        });
		// Parallax scrolling on page header
		$.fn.parallax = function(){
			var carousel = $('.parallax-bg');
			var caption = $('.parallax-txt');
			var mobile = $('#mobile-menu-container');
			if(($(window).width() < 992) && ($(window).scrollTop() > 0)) {
				mobile.addClass('brand-secondary-bg');
			}
			$(window).scroll(function() {
				if(($(this).width() > 1007) && ($(this).scrollTop() < 900)) {
					var st = $(this).scrollTop();
					carousel.css({ 'background-position' : '0 ' + Math.round(st/2) + 'px' });
					caption.css({ 'opacity' : (1 - (st/300)) });
				} else {
					carousel.css({ 'top' : '0' });
					caption.css({ 'opacity' : '1' });
				}
				if(($(this).width() < 992) && ($(this).scrollTop() > 0)) {
					mobile.addClass('brand-secondary-bg');
				}
				if ($(this).scrollTop() == 0) {
					mobile.removeClass('brand-secondary-bg');
				}
			});
		};
		$(document).parallax();
		// Initialize wow.js animate.css animations
		new WOW().init();
		// Initialize responsive flexible content image carousel if present
		$(".image-carousel").owlCarousel({
			responsive : {
				0 : {
					items:1,
					autoplay: true,
					margin:3,
					autoplaySpeed:2000,
					navSpeed:200
				},
				500 : {
					items:2,
					autoplay: true,
					margin:3,
					autoplaySpeed:2000,
					navSpeed:200
				},
				992 : {
					items:2,
					autoplay: true,
					margin:3,
					autoplaySpeed:2000,
					navSpeed:200
				}
			}
		});
		// Initialize flexible content text carousel if present
		$(".content-carousel").owlCarousel({
			items:1,
			navSpeed:200,
			autoHeight:true
		});
		// Initialize lightbox gallery for image carousel
		$('.image-carousel').each(function() {
			$(this).magnificPopup({
				delegate: 'a',
				type: 'image',
				closeBtnInside: false,
				removalDelay: 300,
				mainClass: 'my-mfp-zoom-in',
				gallery: {
				  enabled:true
				}
			});
		});
		// Initialize lightbox for flexible image
		$('.flexible-image a, .image-block a.popup').magnificPopup({
			type: 'image',
			closeBtnInside: false,
			removalDelay: 300,
			mainClass: 'my-mfp-zoom-in'
		});
		// Initialize lightbox for embeds
		$(document).ready( function() {
			$('.popup-embed').magnificPopup({
				type: 'iframe',
				closeBtnInside: false,
				preloader: false,
				removalDelay: 300,
				mainClass: 'my-mfp-zoom-in'
			});
		});
		// Initialize lightbox for content
		$(document).ready( function() {
			$('.popup-content').magnificPopup({
				type: 'inline',
				closeBtnInside: true,
				removalDelay: 300,
				mainClass: 'my-mfp-zoom-in'
			});
		});
		// Initialize responsive collapsible tabs
		fakewaffle.responsiveTabs();
      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
        // Close menus when click outside
        $('.wrap').hover(function(event) { 
            $('#menu-main-menu > li').removeClass('open');
        });
          
        // Initialize desktop menu
        $('ul#menu-main-menu > li').click( function() {
            $('#menu-main-menu > li').removeClass('open');
            $(this).addClass('open');
        });
          
		// Initialize mobile menu
		$('ul.sub-menu').each( function() {
			$(this).prepend('<p class="submenu-title">' + $(this).prev().text() + '</p>');
		});
		$('#mobile-menu-open').click( function() {
			$('#sidebar-menu, #mobile-menu-container, #close-menu, #mobile-menu-open').addClass('open');
			$('ul.nav > li > a').click( function(event) {
				event.preventDefault();
				$(this).next().addClass('open');
				$('a.back-menu').addClass('open');
			});
		});
		$('#close-menu').click( function() {
			$('#sidebar-menu, #sidebar-menu ul#menu-main-menu>li>ul, #mobile-menu-container, #close-menu, #mobile-menu-open, a.back-menu, #menu-main-menu > li').removeClass('open');
		});
		$('a.back-menu').click( function() {
			$('#sidebar-menu ul#menu-main-menu>li>ul, #menu-main-menu > li').removeClass('open');
			$(this).removeClass('open');
		});
      }
    },
    // Home page
    'home': {
      init: function() {
        // JavaScript to be fired on the home page
		// Homepage image carousel
		var owl = $("#home-slideshow");
		owl.owlCarousel({
			animateOut: 'fadeOut',
			animateIn: 'fadeIn',
			items:1,
			autoplay: true,
			loop: true
		});
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // About us page, note the change from about-us to about_us.
    'about_us': {
      init: function() {
        // JavaScript to be fired on the about us page
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
